@if (showTextSelectionOverlay()) {
  @for (rect of this.selectedWordsRect(); track $index) {
    <shared-dp-overlay-rect
      styleClasses="bg-primary opacity-50"
      [rect]="rect"
      [dimension]="dimension()" />
  }
  @let _lasso = lasso();
  @if (_lasso) {
    <shared-dp-overlay-rect
      styleClasses="bg-blue-400 opacity-50"
      [rect]="_lasso"
      [dimension]="dimension()" />
  }
}
